import React from 'react';
import _ from 'lodash';
import {Column} from "../../styled/flex";
import {Button, Input} from "../../styled/form";
import connectFirebase from "../../lib/firebase/connectFirebase";
import styled from 'styled-components';

const AuthInput = styled.input`
margin: 8px 20px;
border: none;
border-radius: 4px;
background-color: #eeeeee;
line-height: 32px;
padding: 0 4px;
text-align: center;
width: 200px;
`;


export class Auth extends React.PureComponent {
  _email = '';
  _password = '';

  render() {
    const {style, className = '', signIn} = this.props;
    return <form style={{
      height: '100%',
      ...style,
    }} className={" " + className} onSubmit={e => {
      e.preventDefault();
      signIn(this._email, this._password);
    }}>
      <Column style={{
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <i className="icon bepro-logo" style={{
          color: 'red',
          fontSize: 100,
          marginBottom: 20
        }}/>
        <AuthInput
          placeholder="email@bepro11.com"
          autoFocus
          type="email"
          onChange={e => this._email = e.target.value}
        />
        <AuthInput
          placeholder="password"
          type="password"
          onChange={e => this._password = e.target.value}
        />
        <Button style={{
          backgroundColor: 'rgb(30,165,255)',
          margin: '16px 20px',
          border: 'none',
          borderRadius: 4,
          color: 'white',
          height: 32,
          width: 200
        }}>Sign in</Button>
      </Column>
    </form>;
  }
}


export const ConnectedAuth = connectFirebase(null, ({firebase}) => {
  return {
    signIn: async (email, password) => {
      try {
        await firebase.auth().signInWithEmailAndPassword(email, password);
      } catch (e) {
        window.alert(e.message);
      }
    }
  };
})(Auth);